<template>
  <div :class="customClasses">
      <div class="carousel-placeholder-wrp">
          <div 
          v-for="(slide,i) in numberOfSlides" :key="i" 
          class="car-placeholder-single"
          :style="`flex-basis:${100 / numberOfSlides}%`"
          >
              <div class="placeholder-slide slide"></div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
    props:{
        numberOfSlides:{
            type:Number,
            default:4
        },
        customClasses:{
            type:String,
            default:'row'
        }
    }
}
</script>

<style>
.carousel-placeholder-wrp{
    display: flex;
}

.row .carousel-placeholder-wrp{
    height: 470px;
}

.row .car-placeholder-single{
    margin-right: 10px;
    margin-left: 10px;
    background-color: rgb(64 64 64);
}

.column .carousel-placeholder-wrp{
    flex-direction: column;
}

.column .car-placeholder-single{
    margin-top: 2%;
    margin-bottom: 2%;
    height: 400px;
    background: #dbdada;;
}

.car-placeholder-single{
    height: 100%;
    border-radius: 10px;
    overflow: hidden;
}

.row .placeholder-slide{
    background-image: linear-gradient(to right, rgba(95, 92, 92, 0.1),rgba(84, 84, 84, 0.9),rgba(95, 92, 92, 0.1));
}

.column .placeholder-slide{
    background-image: linear-gradient(to right, rgba(231, 225, 225, 0.1),rgba(244, 242, 242, 0.9),rgba(231, 225, 225, 0.1));
}

.placeholder-slide{ 
    width: 100%;
    height: 100%;
}

@keyframes slide {
    from { transform:translate(-100%,0); }
    to { transform:translate(200%,0); }
}

.slide{
    animation-name: slide;
    animation-timing-function: ease-in-out;
    animation-iteration-count:infinite;
    animation-duration: 1s;
}
</style>